import Axios from "axios";
import QueryString from "qs";
import MgpStore from "Stores/Store";
import { navigateByService } from "Utils/navigationService";
const { v4: uuidv4 } = require("uuid");
// MgpStore.subscribe(() => MgpStore.getState());

export const CommApiInstance = Axios.create({
    baseURL:process.env.REACT_APP_MGP_BASE_URL,
    withCredentials: true,
    timeout: 30000, // 30초 타임아웃
    headers:{
    },

});
const kstOffset = 1000 * 60 * 60 * 9
CommApiInstance.interceptors.request.use (
    (config) => {
        config.data.apiHdr =  {
            lang:MgpStore.getState().LangSetState.Lang,
            rqstDtime:new Date(Date.now() + kstOffset).toISOString(),
            timeZone:Intl.DateTimeFormat().resolvedOptions().timeZone,
            timeZoneGmt:new Date().toTimeString().slice(9),
            rqstTrxId:uuidv4(),
        }
        return config;
    },
    (error) => {
        
        throw new Error(error.config.data.message);
        
    }
);

CommApiInstance.interceptors.response.use(
    response => {
        const currentPath = window.location.pathname;
        const isConnectEventPage = /^\/Connect\/ConnectEvent(\/|$)/i.test(currentPath);
        const isPreReservationGrandOpenPage = /^\/PreReservation_GrandOpen(\/|$)/i.test(currentPath);
        const isSsoCallbackPath = /^\/login\/sso_callback_(kakao|naver|google|facebook|apple)$/i.test(currentPath);

        // ATHN2303 코드 처리: 로그인 페이지로 이동
        if (response.data && response.data.apiHdr && response.data.apiHdr.code === "ATHN2303") {
            // 특정 이벤트 페이지에서는 자동 리다이렉트를 막고 페이지 단에서 처리한다.
            if (isConnectEventPage || isPreReservationGrandOpenPage) {
                return response;
            }

            const isAppChannel = response.data?.apiBody?.appYn === "Y";
            const loginBaseUrl = isAppChannel ? "/Connect/Login" : "/Login";
            const loginUrl = isSsoCallbackPath
                ? loginBaseUrl
                : `${loginBaseUrl}?referrer=${encodeURIComponent(window.location.pathname + window.location.search)}`;
            const navigated = navigateByService(loginUrl, { replace: true });
            if (!navigated) {
                window.location.href = loginUrl;
            }
            return Promise.reject({ message: "로그인 필요", code: "ATHN2303" });
        }
        return response;
    },
    error => {
        // 타임아웃 에러 처리
        if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
            console.error('요청 타임아웃:', error.config?.url);
            return Promise.reject({ message: "요청 시간이 초과되었습니다.", code: "TIMEOUT" });
        }
        
        // ...existing code...
        const errorUrl = "/Error?error_cd="+error.response?.status;
        //  return window.location.href = errorUrl;
        return Promise.reject(error);
    }
);
